import { validateDateThatNotInFuture } from '@insurancemenu/imenu-components-lib/dist/helpers/validateDateOfBirth';

/**
 * @deprecated use this method from the library
 * Returns the current date and time in the format MM-DD HH:MM.
 */
export const getCurrentDateInMDTFormat = (): string => {
  const now = new Date();
  return `${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(
    now.getHours(),
  ).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
};

/** True when a date is set and is today or in the past (same rule as renew-as-is / cancel coverage). */
export function isEffectiveDatePassed(effectiveDate: string): boolean {
  return effectiveDate !== '' && validateDateThatNotInFuture(effectiveDate);
}
